module.exports = __webpack_public_path__ + "img/Paws.21a9491b.svg";